import React from 'react';
import { Nav } from './components/landing/Nav';
import { Hero } from './components/landing/Hero';
import { SocialProof } from './components/landing/SocialProof';
import { Features } from './components/landing/Features';
import { StyleShowcase } from './components/landing/StyleShowcase';
import { HowItWorks } from './components/landing/HowItWorks';
import { Testimonials } from './components/landing/Testimonials';
import { FAQ } from './components/landing/FAQ';
import { FinalCTA } from './components/landing/FinalCTA';
import { Footer } from './components/landing/Footer';
export function App() {
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-tatan-blue selection:text-white" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <Features data-id="element-5" />
        <StyleShowcase data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FAQ data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}